// extracted by mini-css-extract-plugin
export default {"logo":"LogoLink_logo__oGAz1","black":"LogoLink_black__fZUFQ","white":"LogoLink_white__SWrd7","gradient":"LogoLink_gradient__cJIWC","logoSorgenia":"LogoLink_logoSorgenia__Ozbly"};